module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/amp-icon-370816f0186cb015c912f416a3127c4a.png";